<template>
<div>
  <b-form-group label-for="" v-bind:label="this.fieldData.label" v-bind:description="this.fieldData.label">
    <b-form-select required @change="addThing($event)" v-model="measurementValueDisplay" v-bind:name="this.fieldData.name" :options="this.fieldData.values"></b-form-select>
  </b-form-group>
</div>
</template>
<script>
export default {
  name: 'inputSelect',
  props: {
    field: {
      required: true
    },
    data: {
      required: true
    }
  },
  data () {
    return {
      enteredValue: '',
      fieldData: {},
      measurementValues: []
    }
  },
  mounted () {
    this.enteredValue = this.data
    this.fieldData = this.field
    console.log(this.field)
  },
  watch: {
    data: function (newValue) {
      this.measurementValueDisplay = newValue
    }
  },
  computed: {
    measurementValueDisplay: {
      get: function () {
        return this.enteredValue
      },
      set: function (newValue) {
        this.enteredValue = newValue
      }
    }
  },
  methods: {
    addThing: function (val) {
      if (this.fieldData.onchange) {
        this.$store.dispatch(this.fieldData.onchange, val).then((response) => {
        }).catch((error) => {
          // eslint-disable-next-line
          console.error(error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/form/inputSelect.vue